import { render } from "./product-photo.vue?vue&type=template&id=c37376e0"
import script from "./product-photo.vue?vue&type=script&lang=js"
export * from "./product-photo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__